module.exports = __webpack_public_path__ + "media/fonts/fondamento/Fondamento-Regular-15f13ee119bf6378e8a5592ac3f37681.ttf";